import * as React from 'react'
import {connect} from 'react-redux'
import {Card, CardBody, Col, Row} from "reactstrap";
import {
    ProductFamilyIconsInner,
    Product,
    UsedMainCategoriesInner
} from "src/services/api";
import {WithTranslation, withTranslation} from "react-i18next";
import {ContactType} from "App/constants";
import {contactFormChange, ContactData, contactFormReady} from "App/contactData";
import {UserState} from "App/user";
import {selectConfigurePageAction, selectMainPageAction} from "App/routes";
import {computeAllowSubmit, ContactForm, validateForm} from "Components/ContactForm";
import {AsyncButton} from "Components/AsyncButton";
import {Basket} from "App/basket";

interface StateToProps {
    category: UsedMainCategoriesInner
    subcategory: ProductFamilyIconsInner
    product: Product
    contactData: ContactData;
    basket: Basket;
    type: ContactType;
    user: UserState|null;
}

interface DispatchToProps {
    onContactChange: (data:Object) => void
    onContactSubmit: () => void
    onEdit: (catId:number, subId:number, prodId:number) => void
    goHome: () => void
}

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    onContactChange: (data:Object) => dispatch(contactFormChange(data)),
    onContactSubmit: () => dispatch(contactFormReady(true)),
    onEdit: (catId:number, subId:number, prodId:number) => dispatch(selectConfigurePageAction(catId, subId, prodId)),
    goHome: () => dispatch(selectMainPageAction())
});

class _Component extends React.PureComponent<StateToProps & DispatchToProps & WithTranslation> {

    render() {
        const {category, subcategory, product, type, contactData, basket, t, onContactSubmit, goHome, onEdit, user} = this.props;
        return <Card className="pt-2">
            <CardBody className="bodyslice pb-3">
                <div className="text-title-resume text-uppercase">{t(contactData.formSubmitted?
                    'products.configuration.submitted' + type: 'products.configuration.request' + type)}</div>
            </CardBody>
            <CardBody className="bodyslice pb-3">
                <ContactForm user={user} contactData={contactData} type={type}/>
            </CardBody>
            <CardBody className="bodyslice">
                <Row className="no-gutters py-2 d-print-none">
                    {contactData.formSubmitted ?
                        null :
                        <Col className="pl-0 pr-2 mb-2 col-md-6 align-self-center">
                            <AsyncButton iconClassName={"far fa-edit"} buttonClassName={'w-100'} labelTKey={'products.configuration.modifyconfiguration'}
                                         onSubmit={() => onEdit(category.id, subcategory.id, product.id)}/>
                        </Col>
                    }
                    <Col className="pl-0 pr-2 mb-2 col-md-6 align-self-center">
                        {contactData.formSubmitted ?
                            <AsyncButton iconClassName={"far fa-home"} buttonClassName={'w-100'} labelTKey={'products.configuration.gohome'}
                                         onSubmit={() => goHome()}/> :
                            <AsyncButton disabled={contactData.formSubmitting || basket.syncState.pending || !computeAllowSubmit(this.props)}
                                         iconClassName={"far fa-check-circle"} buttonClassName={'w-100'}
                                         submitting={contactData.formSubmitting} labelTKey={'products.configuration.do' + type}
                                         onSubmit={() => validateForm(this.props)&&onContactSubmit()}/>
                        }
                    </Col>
                </Row>
            </CardBody>
        </Card>
    }
}

export const ContactDetailPage = connect(null, mapDispatchToProps)(withTranslation('common')(_Component));


// WEBPACK FOOTER //
// ./src/components/ContactDetail.tsx